import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body"]

  insert() {
    // Get content from the body target
    const templateContent = this.bodyTarget.innerHTML

    // Find the Trix editor in the form and insert content
    const trixEditor = document.querySelector("trix-editor")
    if (trixEditor && templateContent) {
      trixEditor.editor.loadHTML(templateContent)
    }
  }
}
